/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiSanctionCheckEvent } from './InternalApiSanctionCheckEvent';
import {
    InternalApiSanctionCheckEventFromJSON,
    InternalApiSanctionCheckEventFromJSONTyped,
    InternalApiSanctionCheckEventToJSON,
    InternalApiSanctionCheckEventToJSONTyped,
} from './InternalApiSanctionCheckEvent';
import type { InternalApiPersonStatusEvent } from './InternalApiPersonStatusEvent';
import {
    InternalApiPersonStatusEventFromJSON,
    InternalApiPersonStatusEventFromJSONTyped,
    InternalApiPersonStatusEventToJSON,
    InternalApiPersonStatusEventToJSONTyped,
} from './InternalApiPersonStatusEvent';
import type { InternalApiPersonScreeningAuditEvent } from './InternalApiPersonScreeningAuditEvent';
import {
    InternalApiPersonScreeningAuditEventFromJSON,
    InternalApiPersonScreeningAuditEventFromJSONTyped,
    InternalApiPersonScreeningAuditEventToJSON,
    InternalApiPersonScreeningAuditEventToJSONTyped,
} from './InternalApiPersonScreeningAuditEvent';
import type { InternalApiSnoozeEvent } from './InternalApiSnoozeEvent';
import {
    InternalApiSnoozeEventFromJSON,
    InternalApiSnoozeEventFromJSONTyped,
    InternalApiSnoozeEventToJSON,
    InternalApiSnoozeEventToJSONTyped,
} from './InternalApiSnoozeEvent';
import type { InternalApiDocumentEvent } from './InternalApiDocumentEvent';
import {
    InternalApiDocumentEventFromJSON,
    InternalApiDocumentEventFromJSONTyped,
    InternalApiDocumentEventToJSON,
    InternalApiDocumentEventToJSONTyped,
} from './InternalApiDocumentEvent';

/**
 * 
 * @export
 * @interface InternalApiPersonEvents
 */
export interface InternalApiPersonEvents {
    /**
     * 
     * @type {Array<InternalApiPersonStatusEvent>}
     * @memberof InternalApiPersonEvents
     */
    statuses: Array<InternalApiPersonStatusEvent>;
    /**
     * 
     * @type {Array<InternalApiSnoozeEvent>}
     * @memberof InternalApiPersonEvents
     */
    snoozeHistory: Array<InternalApiSnoozeEvent>;
    /**
     * 
     * @type {InternalApiSanctionCheckEvent}
     * @memberof InternalApiPersonEvents
     */
    latestSanctionCheck?: InternalApiSanctionCheckEvent;
    /**
     * 
     * @type {Array<InternalApiPersonScreeningAuditEvent>}
     * @memberof InternalApiPersonEvents
     */
    flows?: Array<InternalApiPersonScreeningAuditEvent>;
    /**
     * 
     * @type {Array<InternalApiDocumentEvent>}
     * @memberof InternalApiPersonEvents
     */
    documentEvents?: Array<InternalApiDocumentEvent>;
}

/**
 * Check if a given object implements the InternalApiPersonEvents interface.
 */
export function instanceOfInternalApiPersonEvents(value: object): value is InternalApiPersonEvents {
    if (!('statuses' in value) || value['statuses'] === undefined) return false;
    if (!('snoozeHistory' in value) || value['snoozeHistory'] === undefined) return false;
    return true;
}

export function InternalApiPersonEventsFromJSON(json: any): InternalApiPersonEvents {
    return InternalApiPersonEventsFromJSONTyped(json, false);
}

export function InternalApiPersonEventsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiPersonEvents {
    if (json == null) {
        return json;
    }
    return {
        
        'statuses': ((json['statuses'] as Array<any>).map(InternalApiPersonStatusEventFromJSON)),
        'snoozeHistory': ((json['snoozeHistory'] as Array<any>).map(InternalApiSnoozeEventFromJSON)),
        'latestSanctionCheck': json['latestSanctionCheck'] == null ? undefined : InternalApiSanctionCheckEventFromJSON(json['latestSanctionCheck']),
        'flows': json['flows'] == null ? undefined : ((json['flows'] as Array<any>).map(InternalApiPersonScreeningAuditEventFromJSON)),
        'documentEvents': json['documentEvents'] == null ? undefined : ((json['documentEvents'] as Array<any>).map(InternalApiDocumentEventFromJSON)),
    };
}

export function InternalApiPersonEventsToJSON(json: any): InternalApiPersonEvents {
    return InternalApiPersonEventsToJSONTyped(json, false);
}

export function InternalApiPersonEventsToJSONTyped(value?: InternalApiPersonEvents | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'statuses': ((value['statuses'] as Array<any>).map(InternalApiPersonStatusEventToJSON)),
        'snoozeHistory': ((value['snoozeHistory'] as Array<any>).map(InternalApiSnoozeEventToJSON)),
        'latestSanctionCheck': InternalApiSanctionCheckEventToJSON(value['latestSanctionCheck']),
        'flows': value['flows'] == null ? undefined : ((value['flows'] as Array<any>).map(InternalApiPersonScreeningAuditEventToJSON)),
        'documentEvents': value['documentEvents'] == null ? undefined : ((value['documentEvents'] as Array<any>).map(InternalApiDocumentEventToJSON)),
    };
}

